import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import {
  SelectedOrganisationId,
  selectCaisse,
  selectUser,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  createJournalCaisseApi,
  getPrecedentJournalApi,
} from "../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { JournalCaisseDataType } from "../../_App/Types/Forms/JournalCaisseDataType";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { createSessionJournalApi } from "../../_App/Redux/Slices/sessionJournal/sessionJournalSlice";
import { selectedSessionJournal } from "../../_App/Redux/Slices/Auth/authSlice";
import { useTranslation } from "react-i18next";
import { PrintAction } from "../../Shared/Hardware/PrintAction";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const CustomCheckbox = styled.input`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  cursor: pointer;

  &:checked {
    border: 2px solid #007bff;
  }
`;

const CheckboxLabel = styled.label`
  font-size: 16px;
  color: black;
`;

const StyledLabel = styled.label`
  margin-bottom: 16px;
`;

const StyledInput = styled.input`
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #ccc;
  margin-bottom: 16px;
  margin-top: 8px;
  font-size: 16px;
  width: 200px;
  display: inline-block;
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 4px;
`;

const Asterisk = styled.span`
  color: red;
  margin-right: 4px;
`;
const ConfirmationModal = styled(Modal)`
  .modal-dialog {
    max-width: 45%;
    margin: 1.75rem auto;
  }
`;
const JournalCaisseEntryForm = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useAppDispatch();
  const caisse = useAppSelector(selectCaisse);
  const user = useAppSelector(selectUser);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const societe = useAppSelector(societeId);
  const [fontInitial, setFontInitial] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const [initialFontValue, setInitialFontValue] = useState<string | undefined>(
    undefined
  );
    const parametrages = useAppSelector(parametrageCaisse);
  
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [codeJournal, setCodeJournal] = useState<string>("");
  const [showOpeningTicket, setShowOpeningTicket] = useState(false);
  const [Code_jrnl, setCode_jrnl] = useState<string>("");

  const sessionJournal = useAppSelector(selectedSessionJournal);
  const { t } = useTranslation();

  const [showSessionOpeningTicket, setShowSessionOpeningTicket] =
    useState(false);
  const handleSessionOpeningTicketCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowSessionOpeningTicket(e.target.checked);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          getPrecedentJournalApi(caisse?._id || "")
        );
        console.log("response", response);

        if (response.payload) {
          const initialFontValue =
            response.payload.font_final?.toString() || "";
          const initialCodeJournal =
            response.payload.code_journal?.toString() || "";

          setFontInitial(initialFontValue);
          setInitialFontValue(initialFontValue);
          setCodeJournal(initialCodeJournal);
        } else {
          ToastWarning("Erreur inconnue");
        }
      } catch (error) {
        console.error(error);
        ToastWarning("Erreur de traitement des données!!");
      }
    };

    fetchData();
  }, [dispatch, caisse]);

  const handleSave = async () => {
    if (caisse && user) {
      const codeCaisse = localStorage.getItem("idmachine");
      if (codeCaisse) {
        const newJournalEntry: JournalCaisseDataType = {
          id_caisse: caisse._id,
          libelle_caisse: caisse.libelle,
          code_caisse: codeCaisse,
          user_id: user._id,
          font_initial: parseFloat(fontInitial),
          fond_courant: Number(fontInitial),
          // date: new Date(),
          code_journal: generateCodeJournal(),
          cloture: false,
          organisation_id: currentOrganisation,
          societe: societe,
        };
        try {
          const response = await dispatch(
            createJournalCaisseApi(newJournalEntry)
          );

          if (response.payload && response.payload.success) {
            const journalId = response.payload.data._id;
            const journalFontInitial = response.payload.data.font_initial;
            const Code_jrnl = response.payload.data.code_journal;
            setCode_jrnl(Code_jrnl);

            ToastSuccess(response.payload.message);

            if (showOpeningTicket) {
              await printOpeningTicket(response.payload.data);
            }
            const sessionJournalData = {
              journal_id: journalId,
              user_id: response.payload.data.user_id,
              fond_initial: parseFloat(journalFontInitial),
              cloture: false,
            };

            const sessionResponse = await dispatch(
              createSessionJournalApi(sessionJournalData)
            );

            if (sessionResponse.payload && sessionResponse.payload.success) {
              ToastSuccess("Session Journal ajouté avec succès");
              if (showSessionOpeningTicket) {
                await printSessionOpeningTicket(
                  sessionResponse.payload.data,
                  Code_jrnl
                );
              }
            } else {
              ToastWarning(
                sessionResponse.payload
                  ? sessionResponse.payload.message
                  : "Erreur inconnue lors de la création de la session"
              );
            }

            navigate("/caisse");
            onClose();
          } else {
            ToastWarning(
              response.payload ? response.payload.message : "Erreur inconnue"
            );
          }
        } catch (error) {
          console.error(error);
          ToastWarning("Erreur de traitement des données!!");
        }
      } else {
        ToastWarning('aucune machine est associée')
      }
    }
  };

  const handleFontInitialChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    value = value.replace(/[^0-9.]/g, "");

    if (!/^\d+(\.\d*)?$/.test(value)) {
      setErrorMessage("Veuillez saisir un montant valide");
    } else {
      setErrorMessage("");
    }

    setFontInitial(value);
  };

  const generateCodeJournal = () => {
    const currentCode = parseInt(codeJournal.substring(2), 10) || 0;
    const nextCode = currentCode + 1;
    const formattedNextCode = String(nextCode).padStart(6, "0");
    return `CJ${formattedNextCode}`;
  };

  const printOpeningTicket = async (data: any) => {
    try {
      const formattedDateCreate = new Date(data.createdAt).toLocaleString();

      // Contenu du ticket (format texte brut pour imprimante thermique)
      const ticketText = `
        *** Ouverture Caisse ***
${formattedDateCreate}
----------------------------
Organisation : ${user?.selected_organisation?.nom || ""}
Caisse       : ${data.libelle_caisse || ""}
Vendeur      : ${user?.nom || ""} ${user?.prenom || ""}
Fond initial : ${data.font_initial || 0}
Pièce N°     : ${data.code_journal || ""}
----------------------------

Bon démarrage !
\n\n\n
    `;

      // Conversion en Uint8Array (UTF-8)
      const encoder = new TextEncoder();
      const encoded = encoder.encode(ticketText);

      // Envoi à l’imprimante USB
      await PrintAction(encoded,parametrages.OpenTiroire);
    } catch (err) {
      console.error("Erreur lors de la génération du ticket :", err);
    }
  };

  const printSessionOpeningTicket = async (data: any, Code_jrnl: any) => {
    try {
      const formattedDateCreate = new Date(data.createdAt).toLocaleString();

      // Contenu du ticket au format texte brut (compatible imprimante thermique)
      const ticketText = `
        *** Ouverture de session ***
${formattedDateCreate}
----------------------------
Organisation : ${user?.selected_organisation?.nom || ""}
Vendeur       : ${user?.nom || ""} ${user?.prenom || ""}
Code Journal  : ${Code_jrnl || ""}
Fond initial  : ${data.fond_initial || 0}
----------------------------

Bonne session !
\n\n\n
    `;

      // Conversion texte → Uint8Array (UTF-8)
      const encoder = new TextEncoder();
      const encoded = encoder.encode(ticketText);

      // Envoi à l’imprimante
      const result = await PrintAction(encoded,parametrages.OpenTiroire);
      if (result === false) {
        console.warn("L’impression a échoué ou a été annulée.");
      }
    } catch (err) {
      console.error("Erreur lors de la génération du ticket de session :", err);
    }
  };
  const handleOpeningTicketCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowOpeningTicket(e.target.checked);
  };

  return (
    <Modal show={showModal} onHide={() => onClose()}>
      <Modal.Header closeButton>
        <Modal.Title>{t("Ouvrir journal caisse")}</Modal.Title>
      </Modal.Header>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <Modal.Body>
          <StyledLabel>
            {t("Fond initial")} <Asterisk>*</Asterisk>
            <StyledInput
              type="number"
              value={fontInitial}
              onChange={handleFontInitialChange}
            />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          </StyledLabel>
          <CheckboxContainer>
            <CustomCheckbox
              type="checkbox"
              id="printOpeningTicketCheckbox"
              checked={showOpeningTicket}
              onChange={handleOpeningTicketCheckboxChange}
            />
            <CheckboxLabel htmlFor="printOpeningTicketCheckbox">
              {t("Imprimer le ticket d'ouverture de caisse")}
            </CheckboxLabel>
          </CheckboxContainer>
          <CheckboxContainer>
            <CustomCheckbox
              type="checkbox"
              id="printSessionOpeningTicketCheckbox"
              checked={showSessionOpeningTicket}
              onChange={handleSessionOpeningTicketCheckboxChange}
            />
            <CheckboxLabel htmlFor="printSessionOpeningTicketCheckbox">
              {t("Imprimer le ticket d'ouverture de session caisse")}
            </CheckboxLabel>
          </CheckboxContainer>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            className="btn btn-primary-app"
            onClick={() => {
              if (fontInitial !== initialFontValue) {
                setIsConfirmationOpen(true);
              } else {
                handleSave();
              }
            }}
            disabled={!fontInitial.trim() || errorMessage !== ""}
          >
            {t("Enregistrer")}
          </Button>
        </Modal.Footer>
      </form>

      <ConfirmationModal
        show={isConfirmationOpen}
        onHide={() => setIsConfirmationOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title> {t("Confirmation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Êtes-vous sûr que votre fond initial est :")} {fontInitial} ?
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-primary-app"
            onClick={() => setIsConfirmationOpen(false)}
          >
            {t("Annuler")}{" "}
          </Button>
          <Button className="btn btn-primary-app" onClick={handleSave}>
            {t("Enregistrer")}
          </Button>
        </Modal.Footer>
      </ConfirmationModal>
    </Modal>
  );
};
export default JournalCaisseEntryForm;
